//Backend access
import { useQueries } from '@tanstack/react-query';
import bksAPI from "services/api/bks"
import PropTypes from "prop-types";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useMemo } from "react";
import LiveViewDisplay from './display';
import { loadingScreen } from 'utils/wrapper';
import SoftBox from 'components/SoftComponents/SoftBox';
import { useSoftUIController } from 'hooks/context';

function LiveView({ device, nexus_id, selectedOrg, minHeight = '400px', isPerspectiveLiveview = false, isPreview = false, refetch = 3 }) {
  bksAPI.loadToken(useAuth0());

  const [ controller ] = useSoftUIController();
  const { deviceLayout } = controller;

  const uuids = device.hardware_type.includes('bk') ? [device.uuid] : device.uuids;

  const liveviews = useQueries({
    queries: uuids.map((uuid) => ({
      queryKey: ['getLiveView', uuid, nexus_id, selectedOrg],
      queryFn: async () => {
        return await bksAPI.getLiveView(uuid, nexus_id);
      },
      refetchInterval: refetch * 1000,
      staleTime: 0
    }))
  });

  const isLoading = liveviews.some((lv) => lv.isLoading);
  const error = liveviews.find((lv) => lv.error)?.error;

  const memoizedData = useMemo(() => {
    const readyViews = liveviews.filter(lv => lv.data);

    const liveview_urls = readyViews.map((lv) => {
      const base64String = btoa(new Uint8Array(lv.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
      return `data:image/png;base64,${base64String}`;
    });

    return {
      url: liveview_urls,
      cleanup: () => { }
    };
  }, [liveviews.map(lv => lv.dataUpdatedAt).join('-')]);

  if (isLoading) {
    return (
      <SoftBox display="flex" justifyContent="center" alignItems="center" width="100%" minHeight={minHeight}>
        {loadingScreen(controller)}
      </SoftBox>
    );
  }
  if (error) return "Error! " + error.message;

  return <LiveViewDisplay liveviews={memoizedData} {...{ device, deviceLayout, isPerspectiveLiveview, isPreview, minHeight }} />
}

// Typechecking props for the LiveView
LiveView.propTypes = {
  device: PropTypes.object,
  nexus_id: PropTypes.string,
  selectedOrg: PropTypes.string,
  isPerspectiveLiveview: PropTypes.bool,
  isPreview: PropTypes.bool,
  refetch: PropTypes.number
};

export default LiveView;
